import React from 'react';
import { Link } from 'react-router-dom';
import './style.scss';


/**
 * CustomLink
 * @param {String} type button|link
 * @param {Boolean} disabled
 * @param {String} to for link type
 * @param {Boolean} isExternal renders a plain anchor (opens in a new tab) instead of a router link
 * @param {() => {}} onClick for button type; for a router link, also called when it's clicked
 * @param {Boolean} isInline
 * @param {String} className
 * @param {String} prefixIcon
 * @param {String} postfixIcon
 * @param {String} title HTML title attribute for tooltip
 */

const CustomLink = props => {
    const className = `custom-link
         ${props.disabled ? 'custom-link__disabled' : ''}
         ${props.isInline ? 'custom-link__inline' : ''}
         ${props.className || ''}`;

    const content = (
        <div>
            {props.prefixIcon ? <i
                className={`zelpicon ${props.prefixIcon} custom-link_prefix-icon`}
                aria-hidden="true" /> : ''}
            <span>{props.children}</span>
            {props.postfixIcon ? <i
                className={`zelpicon ${props.postfixIcon} custom-link_postfix-icon`}
                aria-hidden="true" /> : ''}
        </div>
    );

    if (props.type === 'button') {
        return (
            // eslint-disable-next-line react/button-has-type
            <button
                onClick={props.onClick || (() => { })}
                tabIndex={props.tabIndex || 0}
                title={props.title}
                className={className}>
                {content}
            </button>
        );
    }

    if (props.isExternal) {
        return (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
                href={!props.disabled ? (props.to || '#') : '#'}
                target="_blank"
                rel="noopener noreferrer"
                tabIndex={props.tabIndex || 0}
                title={props.title}
                className={className}>
                {content}
            </a>
        );
    }

    return (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
            to={!props.disabled ? (props.to || '#') : '#'}
            onClick={props.onClick}
            tabIndex={props.tabIndex || 0}
            title={props.title}
            className={className}>
            {content}
        </Link>
    );
};

export default CustomLink;
